import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class JwtService {
  getToken(): string | null {
    return window.localStorage.getItem('jwtToken');
  }

  setToken(token: string): void {
    window.localStorage.setItem('jwtToken', token);
  }

  destroyToken(): void {
    window.localStorage.removeItem('jwtToken');
  }
}
